module.exports = __webpack_public_path__ + "static/media/ic_questionnaire_pre_medical_warning.a5257b6e.svg";